import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Acesso} from 'src/app/core/acesso';
import {CarregarPerfil} from 'src/app/core/carregar-perfil';
import {ToastService} from 'src/app/services/toast/toast.service';
import {DataUtilService} from 'src/app/services/commons/data-util.service';
import {AcaoExecutada} from "../../../core/acao-executada";
import {AcaoExecutadaService} from "../../../services/acao-executada/acao-executada.service";
import {ComboFuncionario} from "../../../core/combo-funcionario";
import {Funcionario} from "../../../core/funcionario";
import {FrequenciaAcao} from "../../../core/frequencias_acoes";
import {ColaboradorAcao} from "../../../core/colaboradores_acoes";
import {MetaAcaoExecutada} from "../../../core/meta-acao-executada";
import {FuncionarioService} from "../../../services/funcionario/funcionario.service";
import {Atividade} from "../../../core/atividade";
import {Acoes} from "../../../core/acoes";

@Component({
    selector: "app-cadastrar-acao-executada",
    templateUrl: "./cadastrar-acao-executada.component.html",
    styleUrls: ["./cadastrar-acao-executada.component.css"],
})
export class CadastrarAcaoExecutadaComponent implements OnInit {

    atividade: Atividade;
    acao: Acoes = new Acoes();

    acaoExecutada: AcaoExecutada = new AcaoExecutada();

    isAtualizar: boolean = false;

    perfilAcesso: Acesso = new Acesso();
    carregarPerfil: CarregarPerfil = new CarregarPerfil();

    mostrarBotaoCadastrar = true;
    mostrarBotaoAtualizar = true;

    constructor(
        private acaoExecutadaService: AcaoExecutadaService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private toastService: ToastService,
        private dataUtilService: DataUtilService,
        private funcionarioService: FuncionarioService
    ) {
    }

    ngOnInit() {
        this.inicializarObjetos();

        this.carregarPerfil.carregar(
            this.activatedRoute.snapshot.data.perfilAcesso,
            this.perfilAcesso
        );

        if (!this.perfilAcesso.insere) {
            this.mostrarBotaoCadastrar = false;
        }

        if (!this.perfilAcesso.altera) {
            this.mostrarBotaoAtualizar = false;
        }

        let idAcaoExecutada: number;
        idAcaoExecutada = this.activatedRoute.snapshot.queryParams.id
            ? this.activatedRoute.snapshot.queryParams.id
            : null;
        if (idAcaoExecutada) {
            this.isAtualizar = true;
            this.acaoExecutadaService
                .getById(idAcaoExecutada)
                .subscribe((acaoExec: AcaoExecutada) => {
                    this.acaoExecutada = acaoExec;
                    this.acaoExecutada.dataInicio = this.dataUtilService.getDataTruncata(this.acaoExecutada.dataInicio);
                    this.acaoExecutada.dataFim = this.dataUtilService.getDataTruncata(this.acaoExecutada.dataFim);

                    if (this.acaoExecutada && this.acaoExecutada.acao) {
                        this.acao = this.acaoExecutada.acao;
                        this.atividade = this.acao.oficina;
                    }
                });
        }
    }

    inicializarObjetos() {
        this.acaoExecutada = new AcaoExecutada();
    }

    mostrarBotaoLimpar() {
        if (this.isAtualizar) return false;
        if (!this.mostrarBotaoAtualizar) return false;
        if (!this.mostrarBotaoCadastrar) return false;

        return true;
    }

    validarDatas(): boolean {
        const dataInicio = this.dataUtilService.getDataTruncata(this.acaoExecutada.dataInicio);
        const dataFim = this.dataUtilService.getDataTruncata(this.acaoExecutada.dataFim);

        if (dataFim) {
            if (dataInicio && dataInicio.getTime() > dataFim.getTime()) {
                this.toastService.showAlerta("A data de início informada não pode ser maior que a data de fim.");
                return false;
            }
        }
        return true;
    }

    cadastrar() {
        if (!this.validarDatas()) return;
        this.acaoExecutadaService.cadastrar(this.acaoExecutada).subscribe(() => {
            this.toastService.showSucesso("Ação Executada cadastrada com sucesso");
            this.router.navigate(["acaoExecutada"]);
        });
    }

    limpar() {
        this.inicializarObjetos();
    }

    cancelar() {
        this.router.navigate(["acaoExecutada"]);
    }

    atualizar() {
        if (!this.validarDatas()) return;
        this.acaoExecutadaService.alterar(this.acaoExecutada).subscribe(() => {
            this.toastService.showSucesso("Ação Executada atualizada com sucesso");
            this.router.navigate(["acaoExecutada"]);
        });
    }

    onMascaraDataInput(event) {
        return this.dataUtilService.onMascaraDataInput(event);
    }

    onValorChangeFuncionario(registro: ComboFuncionario) {
        if (registro && registro.id) {
            this.funcionarioService.getById(registro.id).subscribe((funcionario: Funcionario) => {
                this.acaoExecutada.funcionarioResponsavel = funcionario;
            })
        }
    }

    addFrequenciaAcao() {
        if (!this.acaoExecutada.frequencias) {
            this.acaoExecutada.frequencias = [];
        }

        const frequenciaAcao: FrequenciaAcao = new FrequenciaAcao();
        frequenciaAcao.id = undefined;
        this.acaoExecutada.frequencias.push(frequenciaAcao);
    }

    addColaboradorAcao() {
        if (!this.acaoExecutada.colaboradores) {
            this.acaoExecutada.colaboradores = [];
        }

        const colaboradorAcao: ColaboradorAcao = new ColaboradorAcao();
        colaboradorAcao.id = undefined;
        this.acaoExecutada.colaboradores.push(colaboradorAcao);
    }

    addMeta() {
        if (!this.acaoExecutada.metas) {
            this.acaoExecutada.metas = [];
        }

        const meta: MetaAcaoExecutada = new MetaAcaoExecutada();
        meta.id = undefined;
        this.acaoExecutada.metas.push(meta);
    }


    onValorChangeAtividade(registro: any) {
        if (registro && registro.id) {
            this.atividade = registro;
            this.acao = new Acoes();
            this.acaoExecutada.acao = new Acoes();
            this.acaoExecutada.metas = [];
        }
    }

    onValorChangeAcao(registro: any) {
        if (registro && registro.id) {
            this.acao = registro;
            this.acaoExecutada.idAcao = registro.id;
        }

    }

    campoDesabilitado(): boolean {
        return ((!this.isAtualizar && !this.perfilAcesso.insere) || (this.isAtualizar && !this.perfilAcesso.altera));
    }

}
